<router-outlet></router-outlet>
<app-nav-bar></app-nav-bar>
